import React, { useRef, useState } from 'react';
import './About.css';
import images from '../../constants/images';
import { about_stats } from '../../constants/data';
import video from '../../assets/videos/wert_introduction.mp4';
import { FaPlay } from 'react-icons/fa';

const About = () => {
  const vidRef = useRef(null);
  const [toggleVideo, setToggleVideo] = useState(false);
  const playVideo = () => {
    setToggleVideo(!toggleVideo);
    if (toggleVideo) vidRef.current.play();
    else vidRef.current.pause();
  };

  return (
    <div className='about section-p'>
      <div className='container'>
        <div className='about-content'>
          <div className='about-grid grid'>
            <img src={images.wert_about} alt='' className='about-img mx-auto rounded-img' />
            <div className='section-title'>
              <h3 className='text-brown'>
                Wert <span className='text-dark'>Digital Development</span>
              </h3>
              <p className='text mx-auto'>
                We are a leading digital development company offering web design, branding, and software development services. Our dedicated team of experts works closely with clients to deliver innovative and tailor-made solutions for their digital needs.
              </p>
            </div>
          </div>

          <div className='about-grid grid'>
            {about_stats.map((about_stat, index) => {
              return (
                <div className='about-item text-center flex' key={index}>
                  <div className='about-item-icon'>
                    <img src={about_stat.image} alt='' className='rounded-img' />
                  </div>
                  <div className='about-item-text text-left'>
                    <h3 className='fs-24 ls-2'>{about_stat.value}</h3>
                    <p className='text'>{about_stat.title}</p>
                  </div>
                </div>
              );
            })}
          </div>

          <div className='about-grid grid'>
            <div className='section-title'>
              <h3 className='text-brown'>
                Video <span className='text-dark'>Presentation</span>
              </h3>
              <p className='text mx-auto'>
              Discover the realm of possibilities with WERT Digital Development – Your Gateway to Innovation and Excellence. 
              Our captivating video presentation unveils the essence of our company, 
              unveiling a world of exceptional services that redefine the digital landscape.
              <br />
              <br />
              Witness firsthand our team of passionate innovators, driven by a relentless pursuit of excellence. 
              With expertise in web design, branding, and software development, 
              we curate exceptional digital experiences tailored to elevate your brand's presence and foster exponential growth.
              <br />
              <br />
              Watch our video presentation to learn more about our company and the range of services we provide. 
              We take pride in our work and aim to exceed our clients' expectations with top-notch digital solutions.
              </p>
            </div>

            <div className='about-video'>
              <video className='about-video rounded-video' autoPlay loop ref={vidRef}>
                <source src={video} type='video/mp4' />
              </video>
              <button type='button' className='vidPlayBtn flex flex-c' onClick={playVideo}>
                <FaPlay className='text-brown' size={28} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
